import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconClipboard12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconClipboard12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M4.5 0a1.5 1.5 0 0 0-1.415 1H2.5A1.5 1.5 0 0 0 1 2.5v8A1.5 1.5 0 0 0 2.5 12h7a1.5 1.5 0 0 0 1.5-1.5v-8A1.5 1.5 0 0 0 9.5 1h-.585A1.5 1.5 0 0 0 7.5 0zm-2 2h.585A1.5 1.5 0 0 0 4.5 3h3a1.5 1.5 0 0 0 1.415-1H9.5a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-8a.5.5 0 0 1 .5-.5m2-1a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1zM6 4.5a.5.5 0 0 1 .5.5v1.5H8a.5.5 0 0 1 0 1H6.5V9a.5.5 0 1 1-1 0V7.5H4a.5.5 0 0 1 0-1h1.5V5a.5.5 0 0 1 .5-.5"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconClipboard12);
